import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import applications from './modules/applications/applications';
import countries from './modules/countries/countries';
import header from './modules/header/header';
import indicators from './modules/indicators/indicators';
import languages from './modules/i18n/languages';
import materials from './modules/materials/materials';
import user from './modules/user/user';
import userApplications from './modules/user/applications';
import userCollection from './modules/user/collection';
import userCompanies from './modules/user/companies';
import userCompositions from './modules/user/compositions';
import userSubmissions from './modules/user/submissions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    applications,
    countries,
    header,
    indicators,
    languages,
    materials,
    user,
    userApplications,
    userCollection,
    userCompanies,
    userCompositions,
    userSubmissions,
  }
});